/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import MobileHeaderToggle from './MobileHeaderToggle';
import MobileMenu from './MobileMenu';

import { MobileHeaderProps } from './_props';

import useHeaderContext from '../header/hooks/useHeaderContext';

/**
 * MobileHeader Component
 */

function MobileHeader({ menuItems, CtaButton, mobileMenuClasses, iconSize, iconClasses }: MobileHeaderProps) {
  const { isMobileMenuOpen, toggleMobileMenu } = useHeaderContext();

  if (!menuItems) return null;

  return (
    <>
      <MobileHeaderToggle
        isMobileMenuOpen={isMobileMenuOpen}
        toggleMobileMenu={toggleMobileMenu}
        iconSize={iconSize}
        iconClasses={iconClasses}
      />

      <MobileMenu
        isMobileMenuOpen={isMobileMenuOpen}
        menuItems={menuItems}
        CtaButton={CtaButton}
        classes={mobileMenuClasses}
      />
    </>
  );
}

/**
 * Exports
 */

export default MobileHeader;
